export const POLICY_STATUS = {
    Active: "Active",
    Deactivated: "Deactivated",
} as const;

export type PolicyStatus = (typeof POLICY_STATUS)[keyof typeof POLICY_STATUS];

export const POLICY_AUTOMATIC = {
    Yes: "Yes",
    No: "No",
} as const;

export type PolicyAutomatic = (typeof POLICY_AUTOMATIC)[keyof typeof POLICY_AUTOMATIC];

export const POLICY_BASE_CURRENCY_OPTIONS = ["USD", "EUR", "GBP", "JPY", "CAD", "AUD", "CHF"] as const;

export type PolicyBaseCurrency = (typeof POLICY_BASE_CURRENCY_OPTIONS)[number];

export const RECEIPT_RETENTION_OPTIONS = ["6 Months", "1 Year", "3 Years", "7 Years", "Indefinitely"] as const;

export type ReceiptRetention = (typeof RECEIPT_RETENTION_OPTIONS)[number];

/** Mirrors `VALID_LOST_RECEIPT_ESCALATION_LEVELS` in admin-services/policy. "Off" means no lost-receipt protocol is configured. */
export const LOST_RECEIPT_ESCALATION_LEVEL = {
    Off: "off",
    Initial: "initial",
    Explanation: "explanation",
} as const;

export type LostReceiptEscalationLevel = (typeof LOST_RECEIPT_ESCALATION_LEVEL)[keyof typeof LOST_RECEIPT_ESCALATION_LEVEL];

export const LOST_RECEIPT_ESCALATION_LEVELS = [
    LOST_RECEIPT_ESCALATION_LEVEL.Off,
    LOST_RECEIPT_ESCALATION_LEVEL.Initial,
    LOST_RECEIPT_ESCALATION_LEVEL.Explanation,
] as const;

export interface ExceptionPolicyRule {
    id: string;
    ruleName: string;
    status: PolicyStatus;
    category: string;
    categoryInactive: boolean;
    expression: string;
    amount: string;
    entryType: string;
    response: string;
}

export interface PoliciesPageInfo {
    totalCount: number;
    cursor: string | null;
    limit: number;
    hasNextPage: boolean;
}

export interface CurrencyRate {
    id: string;
    currency: string;
    currencyCode: string;
    exchangeRate: string;
}

export interface ReceiptPolicyRule {
    id: string;
    ruleName: string;
    status: PolicyStatus;
    requiredAmount: string;
    lostProtocol: string;
    automatic: PolicyAutomatic;
    updatedBy: string;
    changedDate: string;
    requireReceiptAtOrAbove: string;
    retainReceiptsFor: ReceiptRetention;
    allowMultipleImageUploads: boolean;
    lostReceiptEscalationLevel: LostReceiptEscalationLevel;
}

export interface MileagePolicyRule {
    id: string;
    ruleName: string;
    status: PolicyStatus;
    rate: string;
    unit: string;
    updatedBy: string;
    changedDate: string;
}

export const POLICY_FIELD_REQUIREMENT = {
    Mandatory: "mandatory",
    Optional: "optional",
    StronglyRecommended: "strongly-recommended",
} as const;

export type PolicyFieldRequirement = (typeof POLICY_FIELD_REQUIREMENT)[keyof typeof POLICY_FIELD_REQUIREMENT];

export interface PolicyDataFieldConfig {
    id: string;
    label: string;
    enabled: boolean;
    fieldType: string;
    requirement: PolicyFieldRequirement;
    description: string;
}

export interface HotelPolicyDataConfig {
    recommendedFields: PolicyDataFieldConfig[];
    additionalFields: PolicyDataFieldConfig[];
    personalNonReimbursable: PolicyDataFieldConfig;
    outsideHomeCountry: boolean;
    vatFields: PolicyDataFieldConfig[];
}
